import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

export default function AuthLayout({ title, subtitle, badge, children }) {
  return (
    <Box
      component="main"
      sx={{
        minHeight: '100vh', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'background.default', px: 2, py: 5
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.25, mb: 3 }}>
          <Box component="img" src="/sentrivox-symbol.webp" alt="" width={26} height={32} sx={{ display: 'block' }} />
          <Typography component="span" sx={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.01em' }}>
            Sentrivox <Box component="span" sx={{ color: 'text.secondary', fontWeight: 600 }}>Cloud</Box>
          </Typography>
        </Box>
        <Card sx={{ boxShadow: '0 12px 40px rgba(16,24,40,.06)' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 }, '&:last-child': { pb: { xs: 3, sm: 4 } } }}>
            <Box sx={{ textAlign: 'center', mb: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              {badge}
              <Typography variant="h5" component="h1" sx={{ fontWeight: 700, fontSize: 22, letterSpacing: '-0.01em' }}>
                {title}
              </Typography>
              {subtitle && <Typography variant="body2" color="text.secondary">{subtitle}</Typography>}
            </Box>
            {children}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
